export const AppConfig = {
    name: NAME,
    refetchTimeout: 1000 * 3 * 60,
};
